import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";
import AvailabilityRestriction from "@/models/Workers/AvailabilityRestriction";

export default class UpdateWorkerTempAvailabilityRestrictionRequest extends BaseUpdateRequest {
    availabilityRestriction: AvailabilityRestriction = AvailabilityRestriction.None;
}